export const CALENDAR_BUTTON_SIZES = {
  s: { button: 's', icon: '3xs' },
  m: { button: 's', icon: 'xs' },
  l: { button: 'm', icon: 's' },
} as const;
